import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'

class BodyContainer extends Component {

    render() {
        return (
            <Switch>
                {this.props.publicRoutes.map((route, index) => {
                    return <Route key={index}
                        path={route.path}
                        exact={route.exact}
                        render={route.main}
                        title={route.title} />
                })}
                {this.props.privateRoutes.map((route, index) => {
                    return <Route key={index}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => {
                            let element = React.createElement(
                                route.main
                            );
                
                            return React.cloneElement(element, {...props, globalStore: this.props});
                        }}
                        title={route.title} />
                })}
            </Switch>
        );
    }

}

export default BodyContainer;
